export const DAY_NAME = 'dddd';
export const HOUR_MINUTE = 'HH:mm';
export const HOUR_MINUTE_SECOND = 'HH:mm:ss';
export const DEFAULT_TIMEZONE = 'Europe/Paris';
export const DAY_MONTH_YEAR = 'DD/MM/YYYY';
